import { useCallback } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { ELASTICSEARCH_REINDEX_DELAY_MS } from 'helpers/elasticsearch';

export const useInvalidateApplicantsAfterReindex = () => {
  const queryClient = useQueryClient();
  return useCallback(
    () =>
      window.setTimeout(
        () => queryClient.invalidateQueries(['applicants']),
        ELASTICSEARCH_REINDEX_DELAY_MS,
      ),
    [queryClient],
  );
};
